import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "vernika_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminApi = {
  async login(email, password) {
    const { data } = await axios.post(`${API}/admin/login`, { email, password });
    setToken(data.access_token);
    return data;
  },
  async me() {
    const { data } = await axios.get(`${API}/admin/me`, { headers: authHeaders() });
    return data;
  },
  async listEnquiries() {
    const { data } = await axios.get(`${API}/enquiries`, { headers: authHeaders() });
    return data;
  },
  async deleteEnquiry(id) {
    const { data } = await axios.delete(`${API}/enquiries/${id}`, { headers: authHeaders() });
    return data;
  },
  logout() {
    clearToken();
  },
};
